import styled from "styled-components"
import { IDivider } from "../../../gatsby-graphql"
import { colors } from "../../helpers/colors"
import { DividerStyles } from "./divider-styles"
import { BreakPoints, media } from "../../helpers/rwd"

export const Divider = styled.div<IDivider>`
  width: 100%;
  height: 1px;
  margin-top: ${props => `${props.marginTop}px` || "0"};
  margin-bottom: ${props => `${props.marginBottom}px` || "0"};
  background: ${colors.gray};
  ${media.max(BreakPoints.desktop)} {
    display: none;
  }
  ${DividerStyles}
`
